import "./home.css";

import { Link } from "react-router-dom";

import myimage from '../../assets/img/Group.jpg'

function Home() {
  return (
    <div>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-6 port" style={{paddingTop: '150px'}}>
              <h2 className="port-1">I'm Ruth Oladejo</h2>
              <h2 className="port-2">
                <span className="ui">UI</span>/<span className="ux">UX</span>{" "}
                Designer
              </h2>
              <p>
                UI is the saddle, the stirrups, & the reins. UX is the feeling
                you get being able to ride the horse.
              </p>
              <div className="port-btn">
                <Link
                  to="/portfolio"
                  className="btn btn-portfolio mf-1"
                >
                  portfolio
                </Link>

                <Link to="/about" className="btn btn-portfolio mf-2">
                  about
                </Link>
              </div>
            </div>
            <div className="col-md-6 my-image">
              <img src={myimage} alt="ruth" className="img-responsive" />
            </div>
          </div>
        </div>
        {/* social media icon here  */}
        <div className="container not-media">
          <div className="row">
            <div className="col-md-6 soc-med">
            <a
                href="https://www.linkedin.com/in/ruth-oladejo-77753222b/"
                target="_blank" rel="noreferrer"
              >
                <i className="fa fa-linkedin"></i>
              </a>

            </div>
            <div className="col-md-6">
              <div className="port-btn1">
              <a
                href="https://drive.google.com/file/d/1c4MWveDRuTqn07yCqLFnHKZgebtefrK-/view?usp=sharing"
                  target="_blank" rel="noreferrer"
                  className="btn btn-portfolio mf-3"
                >
                  My Curriculum Vitae
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="container media">
          <div className="row">
            <div className="col-md-12">
              <div className="port-btn1 soc-med">
                <Link
                  to="https://www.linkedin.com/in/ruth-oladejo-77753222b/"
                  className="space-link"
                  target="_blank"
                >
                  <i className="fa fa-linkedin"></i>
                </Link>

                <Link
                  to="https://drive.google.com/file/d/14pOq4z5VP5U1PX2cwdmPUw8ej5Z7mwtZ/view?usp=sharing"
                  target="_blank"
                  className="btn btn-portfolio mf-3"
                >
                  My Curriculum Vitae
                </Link>
              </div>
            </div>
          </div>
        </div> */}
      </section>
    </div>
  );
}

export default Home;
